import gql from 'graphql-tag'
import client from '@stores/apollo'
import { IUploadedImageAsset } from '@api/types'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  deleteSpaceAsset: {
    asset: IUploadedImageAsset
  }
}

const mutateHandler = handleFetchResult<IPayload, IUploadedImageAsset>({
  handler: (data) => data.deleteSpaceAsset.asset,
  name: 'Delete Space Asset',
})

export default function deleteSpaceAsset(id: string): Promise<IUploadedImageAsset> {
  return client.gql
    .mutate({
      mutation,
      variables: { input: { id } },
    })
    .then(mutateHandler)
}

const mutation = gql`
  mutation deleteSpaceAsset($input: DeleteSpaceAssetInput!) {
    deleteSpaceAsset(input: $input) {
      asset {
        id
        url
        fileName
        updatedAt
        isDefault
      }
    }
  }
`
